<button type="button" [className]="className" (click)="openModal()">
  <mat-icon *ngIf="icon" class="modal-button__icon" [svgIcon]="isPargoIcon ? icon : ''">
    {{isPargoIcon ? '' : icon}}
  </mat-icon>
  <span *ngIf="amount > 0 && amount && icon" class="modal-button__amount">{{amount}}</span>
  <label class="modal-button__label" *ngIf="label">{{label}}</label>
</button>
